export const LOCALHOST: string = 'http://localhost:8080';